module.exports = __webpack_public_path__ + "static/media/background.3a5f3c77.png";